import clsx, { ClassValue } from 'clsx'
import { useEffect, useState } from 'react'

const MAX_AUDIO_DURATION_MS = 1000 * 60 * 35

type Milliseconds = number

export type AudioDurationProps = {
  startDate: Date | null
  handleStop: () => void
  duration?: Milliseconds
  className?: ClassValue
}

export function AudioDuration (props: AudioDurationProps) {
  const [formatted, setFormatted] = useState<string | null>(null)

  const duration = props.duration ?? MAX_AUDIO_DURATION_MS

  useEffect(() => {
    if (props.startDate !== null) {
      setFormatted('0:00')
      const interval = setInterval(() => {
        const now = new Date()
        const diff = now.getTime() - props.startDate!.getTime()
        const timer = formatTimer(diff)
        setFormatted(timer)
        if (diff > duration) {
          props.handleStop()
        }
      }, 1000)

      return () => {
        clearInterval(interval)
      }
    }
  }, [props.startDate])

  return (
    <div className={clsx(props.className, 'flex', 'items-center', 'gap-2', 'whitespace-nowrap')}>
      <div className="bg-red-500 w-2 h-2 rounded-full" />
      {formatted} / {formatTimer(duration)}
    </div>
  )
}

const formatTimer = (milliseconds: number): string => {
  const seconds = Math.floor(milliseconds / 1000)
  const minutes = Math.floor(seconds / 60)
  const secondsLeft = seconds % 60

  return `${minutes}:${secondsLeft.toString().padStart(2, '0')}`
}
